<nz-layout class="app-layout">
  <nz-sider
    *appShowAuthed="true"
    nzCollapsible
    [nzTrigger]="null"
    class="menu-sidebar"
    [class.is-collapsed]="isCollapsed"
    nzTheme="light"
    nzWidth="256px"
    [nzCollapsedWidth]="80"
    [(nzCollapsed)]="isCollapsed"
    (nzCollapsedChange)="onCollapsedChange($event)"
    >
    <div class="sidebar-logo">
      <a routerLink="/">
        <img src="/assets/img/logo.svg" alt="logo">
      </a>
    </div>
    <div class="sidebar-toolbar">
      <span class="sidebar-toolbar__avatar" nz-dropdown [nzDropdownMenu]="menu" [nzDisabled]="!currentUser" [nzTrigger]="'click'">
        @if (!currentUser) {
          <nz-avatar [nzSize]="32" nzIcon="user"></nz-avatar>
        }
        @if (currentUser) {
          <app-avatar
            [sizePx]="32"
            [fullName]="{ firstName: currentUser.firstName, lastName: currentUser.lastName }"
          ></app-avatar>
        }
      </span>
      <button
        type="button"
        class="sidebar-toolbar__collapse"
        (click)="toggleSidebar()"
        aria-label="Sidebar ein-/ausklappen"
      >
        <i
          nz-icon
          [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
        ></i>
      </button>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item>
            <a (click)="openModal('editMyProfileModal')">Profil bearbeiten</a>
          </li>
          <li nz-menu-item>
            <a routerLink="auth/logout">Ausloggen</a>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed" class="menu">
      @for (item of menuItems; track item; let i = $index) {
        @if (!item.elements) {
          <li
            nz-menu-item
            nzMatchRouter
            [nzMatchRouterExact]="item.exact"
          >
            <a
              [routerLink]="item.routerLink | routerLink"
              [queryParams]="item.routerLink | queryParams"
              [title]="item.name"
              >
              <i nz-icon nzType="{{item.icon}}"></i>
              <span>{{item.name}}</span>
            </a>
          </li>
        }
        @if (item.elements) {
          <li
            nz-submenu
            [nzOpen]="item.isOpen && !isCollapsed"
            [nzTitle]="item.name"
            [nzIcon]="item.icon"
            [attr.title]="item.name"
            (nzOpenChange)="onSubmenuOpenChange(i, $event)"
            (click)="onSubmenuTitleClick($event, i)"
          >
            <ul>
              @for (subitem of item.elements; track subitem) {
                @if (subitem.isGroupLabel) {
                  <li class="menu-section-label">{{subitem.name}}</li>
                } @else {
                  <li
                    nz-menu-item
                    nzMatchRouter
                    [nzMatchRouterExact]="subitem.exact"
                  >
                    @if (!subitem.showModal) {
                      <a
                        [routerLink]="subitem.routerLink | routerLink"
                        [queryParams]="subitem.routerLink | queryParams"
                        [title]="subitem.name"
                      >{{subitem.name}}</a>
                    }
                    @if (subitem.showModal) {
                      <a
                        (click)="openModal(subitem.modalRef, subitem.modalParam)"
                        [title]="subitem.name"
                      >{{subitem.name}}</a>
                    }
                  </li>
                }
              }
            </ul>
          </li>
        }
      }

    </ul>
    <div class="sidebar-footer">
      <app-mobile-app-link class="sidebar-footer__full" label="MOBILE APP"></app-mobile-app-link>
      <app-mobile-app-link class="sidebar-footer__compact" label="MOBILE APP" [compact]="true"></app-mobile-app-link>
      <div class="version">{{ version }}</div>
    </div>
  </nz-sider>
  <nz-layout class="nz-layout-wrapper" [class.is-dashboard]="isDashboard">
    <nz-content>
      <router-outlet (activate)="activatedComponent = $event"></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>


  <app-process-modal globalModal="productionOrderProcessModal" #processModalComponent>
    <span trigger></span>
  </app-process-modal>

  <app-delivery-note-process-modal globalModal="deliveryNoteProcessModal" #deliveryNoteProcessModalComponent></app-delivery-note-process-modal>

  <app-stock-transfer-process-modal globalModal="stockTransferProcessModal" #stockTransferProcessModal (refresh)="refreshStockTransfersList()">
    <span trigger></span>
  </app-stock-transfer-process-modal>

  <app-change-mhd-modal globalModal="changeMhdModal" />

  <app-storage-place-finder-modal globalModal="storagePlaceFinderModal" #storagePlaceFinderModalComponent></app-storage-place-finder-modal>

  <app-edit-my-profile-modal globalModal="editMyProfileModal" (refresh)="getUserDetails(true)"></app-edit-my-profile-modal>

  <app-search-modal
    globalModal="searchModal"
    #searchModalComponent
    (searchChanged)="searchChanged($event)"
    *appShowAuthed="true"
  ></app-search-modal>

  <app-add-edit-order-modal #addEditOrderModalComponent (refresh)="refreshOrdersList()">
    <span trigger></span>
  </app-add-edit-order-modal>
